import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';

import { PortalCloseAccount } from 'playup-web-core';

import useNotify from '../../../hooks/useNotify';
import appConfig from '../../../appConfig';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import { closeAccount } from '../../../api/users';
import { parseApiError } from '../../../utils/parseApiError';
import USstateConfig from '../../constants/USstateConfig';

const isUS = appConfig.regions.isUS;
const usState = appConfig.regions.usState;

const CloseAccount: React.FC = () => {
	const { logout } = React.useContext(PortalSessionContext);
	const [sending, setSending] = React.useState<boolean>(false);
	const [errors, setErrors] = React.useState<APIError>();

	const history = useHistory();
	const notify = useNotify();

	const handleSubmit = () => {
		setSending(true);
		setErrors(undefined);

		closeAccount()
			.then(() => {
				notify({
					type: 'success',
					title: 'Success',
					message: 'Your account has been closed. You are now logged out.',
				});
				logout();
				history.push('/');
			})
			.catch((error) => {
				setErrors(error.errors);
			})
			.finally(() => {
				setSending(false);
			});
	};
	const errorMessage = errors && errors.error && parseApiError(errors);

	return (
		<>
			<Helmet title="Close Account" />
			<PortalCloseAccount
				brandName={appConfig.brand.name}
				responsibleGamblingUrl={appConfig.brand.urls.responsible_gambling_policy}
				termsUrl={appConfig.brand.urls.terms}
				sending={sending}
				errorMessage={errorMessage}
				handleSubmit={handleSubmit}
				isUS={isUS}
				usState={usState}
				usStateConfig={USstateConfig}
			/>
		</>
	);
};

export default CloseAccount;
